import { Box, Text } from '@primer/react';
import Reveal from './Reveal';
import constellation from '../assets/clients/constellation.jpg';
import stateFarm from '../assets/clients/state-farm.jpg';
import kingArchitecturalMetals from '../assets/clients/king-architectural-metals.jpg';
import verizon from '../assets/clients/verizon.jpg';
import copilotEnterprise from '../assets/clients/copilot-enterprise.jpg';
import mckinsey from '../assets/clients/mckinsey.jpg';

const tiles = [
  { image: constellation, area: 'a', name: 'Constellation Energy' },
  { image: stateFarm, area: 'b', name: 'State Farm' },
  { image: kingArchitecturalMetals, area: 'c', name: 'King Architectural Metals' },
  { image: verizon, area: 'd', name: 'Verizon' },
  { image: copilotEnterprise, area: 'e', name: 'GitHub Copilot Enterprise' },
  { image: mckinsey, area: 'f', name: 'McKinsey & Company' },
];

function TrustedBy() {
  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        backgroundColor: '#0d1117',
        paddingY: [7, 8, 9],
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          maxWidth: '1400px',
          margin: '0 auto',
          paddingX: 4,
        }}
      >
        <Box sx={{ position: 'relative' }}>
          <Box
            sx={{
              position: 'relative',
              display: 'grid',
              gridTemplateColumns: ['repeat(2, 1fr)', '0.8fr 1.2fr 1.2fr 0.8fr', '0.8fr 1.2fr 1.2fr 0.8fr'],
              gridTemplateAreas: [
                `"a b" "a b" "c d" "e f"`,
                `"a b c d" "a e f d"`,
                `"a b c d" "a e f d"`,
              ],
              gap: [4, 6, 7],
              height: ['auto', '540px', '600px'],
            }}
          >
            {tiles.map((tile) => (
              <Box
                key={tile.area}
                role="img"
                aria-label={`${tile.name}, Pegasus UX client`}
                sx={{
                  gridArea: tile.area,
                  position: 'relative',
                  minHeight: ['160px', 'auto', 'auto'],
                  borderRadius: '12px',
                  overflow: 'hidden',
                  backgroundImage: `url(${tile.image})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                }}
              >
                <Box sx={{ position: 'absolute', inset: 0, backgroundColor: 'rgba(0, 0, 0, 0.78)' }} />
              </Box>
            ))}
          </Box>

          <Box
            sx={{
              position: 'absolute',
              inset: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 4,
              pointerEvents: 'none',
            }}
          >
            <Reveal>
              <Text
                as="p"
                sx={{
                  margin: 0,
                  maxWidth: '900px',
                  textAlign: 'center',
                  fontFamily: "'Fraunces', serif",
                  fontWeight: 300,
                  fontSize: ['2rem', '3rem', '3.85rem'],
                  lineHeight: 1.3,
                  color: '#f5f1ea',
                  textShadow: '0 2px 24px rgba(0, 0, 0, 0.5)',
                }}
              >
                We're a Dallas-based, full-service UX agency working with ambitious teams everywhere.
              </Text>
            </Reveal>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default TrustedBy;
